import { FAB } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const FABDemo = () => {
  const args = {
    icon: 'add',
    text: '',
    size: 'regular',
    cornerRadius: 'rounded' as any,
    backgroundColor: 'primary-10' as any,
    elevation: 'lg' as any,
    typography: 'label-large',
    align: 'end',
    badgeText: '3',
  }
  return (
    <LayoutDemo title='FAB' bgColor='var(--color-primary-80)'>
      <div className='w-full h-full flex items-end justify-end'>
        <FAB {...args} />
      </div>
    </LayoutDemo>
  )
}
